import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import styled from 'styled-components';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledButton = styled(UIButton).withConfig({
  displayName: "MessageActionsDropdownButton__StyledButton",
  componentId: "ri5b6g-0"
})(["&&&{margin-left:0px;}"]);
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "MessageActionsDropdownButton__StyledIcon",
  componentId: "ri5b6g-1"
})(["margin-right:0px;"]);
const MessageActionsDropdownButton = ({
  buttonIcon,
  children,
  tooltipProps,
  disabled,
  onClick,
  'data-test-id': dataTestId = 'message-actions-dropdown-button'
}) => {
  const Wrapper = tooltipProps ? UITooltip : Fragment;
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({}, tooltipProps, {
    children: /*#__PURE__*/_jsxs(StyledButton, {
      use: 'transparent',
      onClick: onClick,
      "data-test-id": dataTestId,
      role: 'menuitem',
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(StyledIcon, {
        name: buttonIcon,
        size: 16
      }), children]
    })
  }));
};
MessageActionsDropdownButton.displayName = 'MessageActionsDropdownButton';
export default MessageActionsDropdownButton;